// HTML Slides Generator - Copilot Design Style
// Generates a standalone HTML file with slide navigation

const COPILOT_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { font-family: 'Inter', -apple-system, sans-serif; background: #1a1a2e; overflow: hidden; }
  .slide-container { width: 100vw; height: 100vh; position: relative; }
  .slide { width: 100%; height: 100%; position: absolute; top: 0; left: 0; opacity: 0; pointer-events: none; transition: opacity 0.4s ease; display: flex; flex-direction: column; padding: 48px 60px; background: linear-gradient(135deg, #F5F0EB 0%, #FFF8F0 100%); }
  .slide.active { opacity: 1; pointer-events: auto; }

  /* Header */
  .slide-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 32px; }
  .slide-title { font-size: 32px; font-weight: 700; color: #1a1a2e; display: flex; align-items: center; gap: 12px; }
  .slide-subtitle { font-size: 14px; color: #64748B; font-weight: 400; }
  .slide-meta { text-align: right; }
  .slide-date { font-size: 13px; color: #94A3B8; }
  .slide-page { font-size: 12px; color: #CBD5E1; margin-top: 4px; }

  /* Content area */
  .slide-body { flex: 1; overflow: hidden; }

  /* Cards */
  .card { background: #ffffff; border-radius: 16px; padding: 24px; box-shadow: 0 1px 3px rgba(0,0,0,0.06); }
  .card-title { font-size: 14px; font-weight: 600; color: #1a1a2e; margin-bottom: 16px; display: flex; align-items: center; gap: 8px; }

  /* Tables */
  .s-table { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 12px; }
  .s-table thead th { background: #F8FAFC; color: #64748B; font-weight: 600; text-align: left; padding: 10px 14px; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px; }
  .s-table thead th:first-child { border-radius: 10px 0 0 0; }
  .s-table thead th:last-child { border-radius: 0 10px 0 0; }
  .s-table tbody td { padding: 10px 14px; border-bottom: 1px solid #F1F5F9; color: #334155; }
  .s-table tbody tr:last-child td { border-bottom: none; }
  .s-table tbody tr:hover { background: #FAFAF8; }

  /* Badges */
  .badge { display: inline-block; padding: 3px 10px; border-radius: 20px; font-size: 11px; font-weight: 600; }
  .badge-green { background: #DCFCE7; color: #166534; }
  .badge-blue { background: #DBEAFE; color: #1E40AF; }
  .badge-purple { background: #F3E8FF; color: #6B21A8; }
  .badge-yellow { background: #FEF9C3; color: #854D0E; }
  .badge-red { background: #FEE2E2; color: #991B1B; }
  .badge-teal { background: #CCFBF1; color: #115E59; }
  .badge-gray { background: #F1F5F9; color: #64748B; }
  .badge-orange { background: #FFEDD5; color: #9A3412; }

  /* Stats grid */
  .stats-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); gap: 16px; margin-bottom: 24px; }
  .stat-card { background: #ffffff; border-radius: 14px; padding: 20px; text-align: center; box-shadow: 0 1px 3px rgba(0,0,0,0.06); }
  .stat-value { font-size: 36px; font-weight: 700; color: #6366F1; }
  .stat-label { font-size: 12px; color: #94A3B8; margin-top: 4px; font-weight: 500; }

  /* Progress bar */
  .progress-bar { height: 8px; background: #E2E8F0; border-radius: 4px; overflow: hidden; }
  .progress-fill { height: 100%; border-radius: 4px; transition: width 0.3s; }

  /* Parity matrix */
  .parity-cell { width: 28px; height: 28px; border-radius: 6px; display: inline-flex; align-items: center; justify-content: center; font-size: 10px; font-weight: 700; color: white; }

  /* Week pills */
  .week-pill { display: inline-block; padding: 4px 12px; border-radius: 20px; font-size: 13px; font-weight: 600; margin-right: 8px; margin-bottom: 6px; }
  .week-current { background: #6366F1; color: white; }
  .week-past { background: #E2E8F0; color: #64748B; }
  .week-future { background: #F8FAFC; color: #CBD5E1; border: 1px solid #E2E8F0; }

  /* Item list */
  .item-row { display: flex; align-items: center; gap: 12px; padding: 8px 0; border-bottom: 1px solid #F1F5F9; }
  .item-row:last-child { border-bottom: none; }
  .item-title { flex: 1; font-size: 13px; color: #334155; }
  .item-owner { font-size: 11px; color: #94A3B8; min-width: 80px; }

  /* RAG indicator */
  .rag { width: 14px; height: 14px; border-radius: 50%; display: inline-block; }
  .rag-green { background: #22C55E; }
  .rag-yellow { background: #EAB308; }
  .rag-red { background: #EF4444; }
  .rag-gray { background: #CBD5E1; }

  /* Navigation */
  .nav-bar { position: fixed; bottom: 0; left: 0; right: 0; height: 48px; background: rgba(26,26,46,0.95); display: flex; align-items: center; justify-content: center; gap: 16px; z-index: 100; backdrop-filter: blur(10px); }
  .nav-dot { width: 10px; height: 10px; border-radius: 50%; background: rgba(255,255,255,0.3); cursor: pointer; transition: all 0.3s; border: none; display: none; }
  .nav-dot.active { background: #6366F1; transform: scale(1.3); }
  .nav-dot:hover { background: rgba(255,255,255,0.6); }
  .section-nav { display: flex; gap: 4px; align-items: center; flex-wrap: nowrap; }
  .section-btn { padding: 6px 16px; border-radius: 20px; border: 1px solid rgba(255,255,255,0.15); background: rgba(255,255,255,0.06); color: rgba(255,255,255,0.5); font-size: 12px; font-weight: 500; cursor: pointer; transition: all 0.25s; white-space: nowrap; letter-spacing: 0.3px; }
  .section-btn:hover { background: rgba(255,255,255,0.12); color: rgba(255,255,255,0.8); border-color: rgba(255,255,255,0.25); }
  .section-btn.active { background: rgba(99,102,241,0.2); color: #A78BFA; border-color: rgba(99,102,241,0.4); font-weight: 600; }
  .section-sep { width: 1px; height: 16px; background: rgba(255,255,255,0.1); margin: 0 2px; }
  .nav-arrow { background: none; border: none; color: rgba(255,255,255,0.5); font-size: 20px; cursor: pointer; padding: 8px; }
  .nav-arrow:hover { color: white; }
  .nav-count { color: rgba(255,255,255,0.5); font-size: 12px; font-family: 'Inter', sans-serif; }

  /* Two-column layout */
  .two-col { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; }
  .three-col { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 16px; }

  /* Section divider */
  .section-label { font-size: 13px; font-weight: 600; color: #6366F1; margin: 16px 0 8px; text-transform: uppercase; letter-spacing: 0.5px; }

  /* Highlights / Lowlights */
  .highlight-box { background: #F0FDF4; border-left: 3px solid #22C55E; padding: 12px 16px; border-radius: 0 10px 10px 0; margin-bottom: 8px; font-size: 12px; color: #166534; }
  .lowlight-box { background: #FEF2F2; border-left: 3px solid #EF4444; padding: 12px 16px; border-radius: 0 10px 10px 0; margin-bottom: 8px; font-size: 12px; color: #991B1B; }

  /* Footer branding */
  .slide-footer { position: absolute; bottom: 56px; left: 60px; right: 60px; display: flex; justify-content: space-between; align-items: center; }
  .brand { font-size: 11px; color: #CBD5E1; font-weight: 500; letter-spacing: 1px; }
`

const STATUS_BADGE = {
  'GA': 'badge-green', 'Done': 'badge-green',
  'External Flight': 'badge-teal', 'Beta Flight': 'badge-purple',
  'Dev': 'badge-blue', 'RFC': 'badge-yellow',
  'Not started': 'badge-gray', 'No plan': 'badge-gray',
  'Cut': 'badge-red', 'TBD': 'badge-gray',
}

const PARITY_COLORS = {
  'GA': '#22C55E', 'Done': '#22C55E', 'External Flight': '#14B8A6', 'Beta Flight': '#A855F7',
  'Dev': '#3B82F6', 'RFC': '#EAB308', 'Not started': '#CBD5E1', 'No plan': '#E2E8F0', 'NA': '#F1F5F9',
}

const PLATFORM_LABELS = { iosMobile: 'iOS', androidMobile: 'Android', cmc: 'CMC', ipad: 'iPad', androidTablet: 'Tab', windowsApp: 'Win', mac: 'Mac' }
const PLATFORM_KEYS = ['iosMobile', 'androidMobile', 'cmc', 'ipad', 'androidTablet', 'windowsApp', 'mac']

function badge(text, type) {
  return `<span class="badge ${type || STATUS_BADGE[text] || 'badge-gray'}">${text}</span>`
}

function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') }

function truncate(s, n) { return !s ? '' : s.length > n ? s.slice(0, n - 1) + '…' : s }

// --- SLIDE GENERATORS ---

function slideCover(title, date) {
  return `
    <div class="slide" data-section="Cover" style="justify-content: center; align-items: center; text-align: center; background: linear-gradient(160deg, #1B1B32 0%, #242445 30%, #3B2F80 60%, #7B6DD8 85%, #A78BFA 100%); position: relative; overflow: hidden;">
      <!-- Copilot-style gradient orbs -->
      <div style="position:absolute;top:-120px;right:-80px;width:500px;height:500px;border-radius:50%;background:radial-gradient(circle,rgba(123,109,216,0.3) 0%,transparent 70%);"></div>
      <div style="position:absolute;bottom:-150px;left:-100px;width:600px;height:600px;border-radius:50%;background:radial-gradient(circle,rgba(99,102,241,0.2) 0%,transparent 70%);"></div>
      <div style="position:absolute;top:50%;left:10%;width:300px;height:300px;border-radius:50%;background:radial-gradient(circle,rgba(167,139,250,0.15) 0%,transparent 70%);"></div>
      <div style="position:relative;z-index:1;color:white;">
        <div style="font-size:64px;margin-bottom:24px;">✨</div>
        <div style="font-size: 44px; font-weight: 700; margin-bottom: 12px; letter-spacing: -0.5px;">${esc(title)}</div>
        <div style="margin-top: 48px; padding-top: 24px; border-top: 1px solid rgba(255,255,255,0.15);">
          <div style="font-size: 14px; color: rgba(255,255,255,0.4); font-weight: 300;">${esc(date)}</div>
        </div>
      </div>
    </div>`
}

function slideDashboard(workItems) {
  const statusCounts = {}
  workItems.forEach(i => { statusCounts[i.status] = (statusCounts[i.status] || 0) + 1 })
  const total = workItems.length
  const done = (statusCounts['GA'] || 0) + (statusCounts['Done'] || 0)
  const inFlight = (statusCounts['External Flight'] || 0) + (statusCounts['Beta Flight'] || 0)
  const dev = statusCounts['Dev'] || 0
  const cut = statusCounts['Cut'] || 0

  const statsHtml = `
    <div class="stats-grid">
      <div class="stat-card"><div class="stat-value">${total}</div><div class="stat-label">Total Items</div></div>
      <div class="stat-card"><div class="stat-value" style="color:#22C55E">${done}</div><div class="stat-label">GA / Done</div></div>
      <div class="stat-card"><div class="stat-value" style="color:#14B8A6">${inFlight}</div><div class="stat-label">In Flight</div></div>
      <div class="stat-card"><div class="stat-value" style="color:#3B82F6">${dev}</div><div class="stat-label">In Dev</div></div>
      <div class="stat-card"><div class="stat-value" style="color:#EF4444">${cut}</div><div class="stat-label">Cut</div></div>
    </div>`

  const pct = total ? Math.round((done / total) * 100) : 0
  const progressHtml = `
    <div class="card" style="margin-bottom:24px">
      <div class="card-title">Overall Progress</div>
      <div style="display:flex;align-items:center;gap:16px;">
        <div class="progress-bar" style="flex:1"><div class="progress-fill" style="width:${pct}%;background:linear-gradient(90deg,#22C55E,#6366F1)"></div></div>
        <span style="font-size:20px;font-weight:700;color:#6366F1">${pct}%</span>
      </div>
    </div>`

  const barEntries = Object.entries(statusCounts).sort((a, b) => b[1] - a[1])
  const maxVal = Math.max(...barEntries.map(e => e[1]))
  const barsHtml = barEntries.map(([s, c]) => {
    const w = Math.round((c / maxVal) * 100)
    const color = PARITY_COLORS[s] || '#94A3B8'
    return `<div style="display:flex;align-items:center;gap:12px;margin-bottom:8px;">
      <span style="min-width:120px;font-size:12px;color:#64748B;text-align:right">${esc(s)}</span>
      <div style="flex:1;height:24px;background:#F1F5F9;border-radius:6px;overflow:hidden">
        <div style="width:${w}%;height:100%;background:${color};border-radius:6px;display:flex;align-items:center;justify-content:flex-end;padding-right:8px">
          <span style="font-size:11px;font-weight:600;color:white">${c}</span>
        </div>
      </div>
    </div>`
  }).join('')

  return slideWrap('📊 Cycle Overview', `${statsHtml}${progressHtml}<div class="card"><div class="card-title">Status Distribution</div>${barsHtml}</div>`, 'Cycle Overview')
}

function slideWorkItems(workItems, pageIdx, totalPages) {
  const rows = workItems.map(item => `
    <tr>
      <td style="font-weight:500;max-width:280px">${esc(truncate(item.title, 50))}</td>
      <td>${esc(item.ownerName || item.owner || '—')}</td>
      <td>${item.priority ? badge(item.priority, item.priority === 'P0' ? 'badge-red' : item.priority === 'P1' ? 'badge-orange' : 'badge-blue') : '—'}</td>
      <td>${badge(item.status || '—')}</td>
      <td>${item.flightWeek ? badge(item.flightWeek, 'badge-purple') : '—'}</td>
    </tr>`).join('')

  const subtitle = totalPages > 1 ? ` (${pageIdx + 1}/${totalPages})` : ''
  return slideWrap(`📋 Work Items${subtitle}`, `
    <div class="card" style="overflow:auto;flex:1">
      <table class="s-table">
        <thead><tr><th>Title</th><th>Owner</th><th>Priority</th><th>Status</th><th>Flight</th></tr></thead>
        <tbody>${rows}</tbody>
      </table>
    </div>`, 'Work Items')
}

function emailToName(email, members) {
  if (!email) return '—'
  if (members && members.length) {
    const m = members.find(m => m.email === email)
    if (m) return m.name || m.fullName || m.alias || email
  }
  // Fallback: extract name from email
  const local = email.split('@')[0]
  return local.split('.').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ')
}

function slideWorkItemsGrouped(workItems, members) {
  const statusOrder = ['GA', 'Done', 'External Flight', 'Beta Flight', 'Dev', 'RFC', 'Not started', 'TBD', 'Cut']
  const statusGroups = {}
  workItems.forEach(item => {
    const s = item.status || 'TBD'
    if (!statusGroups[s]) statusGroups[s] = []
    statusGroups[s].push(item)
  })

  const slides = []
  const PER_PAGE = 12

  const orderedStatuses = statusOrder.filter(s => statusGroups[s]?.length)
  // Add any statuses not in order
  Object.keys(statusGroups).forEach(s => { if (!orderedStatuses.includes(s)) orderedStatuses.push(s) })

  // Pack multiple status groups per slide until PER_PAGE
  let currentItems = []
  let currentLabels = []

  const flushSlide = () => {
    if (!currentItems.length) return
    const rows = currentItems.map(({ item, isHeader }) => {
      if (isHeader) {
        return `<tr><td colspan="5" style="padding:14px 16px 6px;border-bottom:2px solid #E2E8F0">
          <span style="font-size:13px;font-weight:700;color:#6366F1;text-transform:uppercase;letter-spacing:0.5px">${badge(item.status)} ${esc(item.status)} (${item.count})</span>
        </td></tr>`
      }
      const ownerName = item.ownerName || emailToName(item.owner, members)
      const note = item.highlights ? `💡 ${truncate(item.highlights, 30)}` : item.lowlights ? `⚠️ ${truncate(item.lowlights, 30)}` : ''
      const noteColor = item.highlights ? '#2E7D32' : item.lowlights ? '#C62828' : '#94A3B8'
      return `<tr>
        <td style="font-weight:500;max-width:240px;padding:8px 16px">${esc(truncate(item.title, 40))}</td>
        <td style="padding:8px 12px;font-size:11px;color:${noteColor};font-style:italic;max-width:180px">${esc(note)}</td>
        <td style="padding:8px 12px;font-size:12px;color:#64748B">${esc(item.mission || '—')}</td>
        <td style="padding:8px 12px">${esc(ownerName)}</td>
        <td style="padding:8px 12px">${item.flightWeek ? badge(item.flightWeek, 'badge-purple') : '—'}</td>
      </tr>`
    }).join('')

    const label = currentLabels.join(' · ')
    slides.push(slideWrap(`📋 Work Items — ${label}`, `
      <div class="card" style="overflow:auto;flex:1;padding:0">
        <table class="s-table" style="font-size:13px">
          <thead><tr><th style="padding:12px 16px;min-width:180px">Title</th><th style="padding:12px 16px">Notes</th><th style="padding:12px 16px">Mission</th><th style="padding:12px 16px">Owner</th><th style="padding:12px 16px">Flight</th></tr></thead>
          <tbody>${rows}</tbody>
        </table>
      </div>`, 'Work Items'))
    currentItems = []
    currentLabels = []
  }

  orderedStatuses.forEach(status => {
    const group = statusGroups[status]
    // If adding this group would overflow, flush first
    if (currentItems.length > 0 && currentItems.length + group.length + 1 > PER_PAGE) {
      flushSlide()
    }
    currentItems.push({ item: { status, count: group.length }, isHeader: true })
    currentLabels.push(status)
    group.forEach(item => {
      currentItems.push({ item, isHeader: false })
      if (currentItems.length >= PER_PAGE) {
        flushSlide()
        // Continue same status on next slide
        currentLabels.push(status + ' (cont.)')
      }
    })
  })
  flushSlide()

  return slides
}

function slideWoW(weekLabel, items, summary, members) {
  const completed = items.filter(i => ['GA', 'Done', 'External Flight'].includes(i.status))
  const inProgress = items.filter(i => ['Dev', 'Beta Flight', 'RFC'].includes(i.status))
  const other = items.filter(i => !['GA', 'Done', 'External Flight', 'Dev', 'Beta Flight', 'RFC', 'Cut'].includes(i.status))
  const cut = items.filter(i => i.status === 'Cut')

  const statusEmoji = { 'GA': '✅', 'Done': '✅', 'External Flight': '✈️', 'Beta Flight': '🛩️', 'Dev': '🔨', 'RFC': '📋', 'Not started': '⬜', 'Cut': '✂️', 'TBD': '❓' }

  let ragHtml = ''
  if (summary) {
    const ragColor = summary.rag === 'green' ? 'rag-green' : summary.rag === 'yellow' ? 'rag-yellow' : summary.rag === 'red' ? 'rag-red' : 'rag-gray'
    ragHtml = `<div style="display:flex;align-items:center;gap:8px;margin-bottom:16px"><span class="rag ${ragColor}"></span><span style="font-size:14px;font-weight:600;color:#1a1a2e">Weekly Status</span></div>`
    if (summary.highlights) ragHtml += `<div class="highlight-box">✅ ${esc(summary.highlights)}</div>`
    if (summary.lowlights) ragHtml += `<div class="lowlight-box">⚠️ ${esc(summary.lowlights)}</div>`
  }

  const renderItem = (i) => {
    const ownerName = emailToName(i.owner, members)
    const emoji = statusEmoji[i.status] || '📌'
    let detail = ''
    if (i.highlights) {
      detail = `<span style="font-size:11px;color:#2E7D32;margin-left:6px;font-style:italic">💡 ${esc(truncate(i.highlights, 50))}</span>`
    } else if (i.lowlights) {
      detail = `<span style="font-size:11px;color:#C62828;margin-left:6px;font-style:italic">⚠️ ${esc(truncate(i.lowlights, 50))}</span>`
    } else {
      detail = `<span style="font-size:11px;color:#94A3B8;margin-left:6px">📊 ${esc(i.status)}</span>`
    }
    return `<div class="item-row" style="display:flex;align-items:center;justify-content:space-between;gap:8px">
      <div style="display:flex;align-items:center;gap:6px;flex:1;min-width:0">
        ${badge(i.status)}
        <span class="item-title" style="font-weight:500">${esc(truncate(i.title, 42))}</span>
        ${detail}
      </div>
      <span style="font-size:12px;color:#64748B;white-space:nowrap;min-width:90px;text-align:right">${esc(ownerName)}</span>
    </div>`
  }

  const renderList = (label, icon, list) => {
    if (!list.length) return ''
    return `<div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:4px;padding:0 4px">
      <div class="section-label" style="margin-bottom:0">${icon} ${label} (${list.length})</div>
      <span style="font-size:10px;color:#94A3B8;font-weight:600;text-transform:uppercase;letter-spacing:0.5px">Feature Owner</span>
    </div>` + list.map(renderItem).join('')
  }

  const leftContent = renderList('Completed', '✅', completed) + renderList('In Progress', '🔄', inProgress)
  const rightContent = renderList('Planned', '📋', other) + renderList('Cut', '✂️', cut)

  let content
  if (!rightContent) {
    content = `${ragHtml}<div class="card">${leftContent}</div>`
  } else if (!leftContent) {
    content = `${ragHtml}<div class="card">${rightContent}</div>`
  } else {
    content = `${ragHtml}<div class="two-col"><div class="card">${leftContent}</div><div class="card">${rightContent}</div></div>`
  }

  return slideWrap(`📅 ${weekLabel}`, content, 'WoW Plan')
}

function slideFeatureParity(items) {
  const clientItems = items.filter(i => i.type === 'client')
  const PER_PAGE = 8
  const pages = Math.ceil(clientItems.length / PER_PAGE)
  const slides = []

  // Match website colors exactly
  const SC = {
    'GA': { bg: '#E8F5E9', text: '#2E7D32', emoji: '✅' },
    'Done': { bg: '#E8F5E9', text: '#2E7D32', emoji: '✅' },
    'External Flight': { bg: '#E0F2F1', text: '#00695C', emoji: '✈️' },
    'Beta Flight': { bg: '#F3E5F5', text: '#7B1FA2', emoji: '🛩️' },
    'Dev': { bg: '#E3F2FD', text: '#1565C0', emoji: '🔨' },
    'RFC': { bg: '#FFF8E1', text: '#F57F17', emoji: '📋' },
    'Not started': { bg: '#F5F5F5', text: '#616161', emoji: '⬜' },
    'No plan': { bg: 'transparent', text: '#9E9E9E', emoji: '—' },
    'NA': { bg: '#FAFAFA', text: '#BDBDBD', emoji: '' },
  }

  function renderStatusBadge(st, eta) {
    if (st === 'NA') return `<span style="color:#ccc;font-size:11px">N/A</span>`
    if (st === 'No plan') return `<span style="color:#bbb;font-size:11px">—</span>`
    const c = SC[st] || { bg: '#F5F5F5', text: '#616161', emoji: '' }
    let html = `<div style="display:flex;flex-direction:column;align-items:center;gap:2px">`
    html += `<span style="font-size:11px;padding:3px 10px;border-radius:20px;font-weight:500;display:inline-flex;align-items:center;background:${c.bg};color:${c.text}">${c.emoji} ${esc(st)}</span>`
    if (eta && st !== 'NA' && st !== 'No plan') {
      const d = new Date(eta)
      const formatted = !isNaN(d.getTime()) ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : eta
      html += `<span style="font-size:10px;color:#94A3B8">${esc(formatted)}</span>`
    }
    html += `</div>`
    return html
  }

  for (let p = 0; p < pages; p++) {
    const pageItems = clientItems.slice(p * PER_PAGE, (p + 1) * PER_PAGE)
    const headerCells = PLATFORM_KEYS.map(pk => `<th style="text-align:center;padding:10px 6px;min-width:90px;font-size:12px">${PLATFORM_LABELS[pk]}</th>`).join('')

    const rows = pageItems.map((item, idx) => {
      const bgColor = idx % 2 === 0 ? '#FFFFFF' : '#FAFBFC'
      const cells = PLATFORM_KEYS.map(pk => {
        const st = item.platforms?.[pk]?.status || 'NA'
        const eta = item.platforms?.[pk]?.eta || ''
        return `<td style="text-align:center;padding:8px 6px;vertical-align:middle">${renderStatusBadge(st, eta)}</td>`
      }).join('')

      // Parity % with website colors
      const pctMatch = (item.parity || '').match(/(\d+)/)
      const pctVal = pctMatch ? parseInt(pctMatch[1]) : 0
      const pctColor = pctVal > 50 ? '#2E7D32' : pctVal > 0 ? '#F57F17' : '#C62828'

      return `<tr style="background:${bgColor}">
        <td style="padding:10px 16px;font-weight:500;font-size:13px;color:#1a1a2e;text-align:left;min-width:200px">${esc(truncate(item.feature, 40))}</td>
        <td style="padding:10px 16px;font-size:12px;color:#64748B;text-align:left;min-width:120px">${esc(item.mission || '')}</td>
        <td style="padding:10px 16px;text-align:center"><span style="font-weight:600;color:${pctColor}">${esc(item.parity || '—')}</span></td>
        ${cells}
      </tr>`
    }).join('')

    const subtitle = pages > 1 ? ` (${p + 1}/${pages})` : ''
    slides.push(slideWrap(`📊 Feature Parity — Client${subtitle}`, `
      <div class="card" style="overflow:auto;flex:1;padding:0">
        <table class="s-table" style="font-size:13px">
          <thead><tr>
            <th style="padding:10px 16px;text-align:left;min-width:200px">Feature</th>
            <th style="padding:10px 16px;text-align:left;min-width:120px">Mission</th>
            <th style="padding:10px 16px;text-align:center;min-width:80px">Parity</th>
            ${headerCells}
          </tr></thead>
          <tbody>${rows}</tbody>
        </table>
      </div>`, 'Feature Parity'))
  }

  return slides
}

function slideFeatureParityPicasso(items) {
  const picassoItems = items.filter(i => i.type === 'picasso')
  if (!picassoItems.length) return ''

  const rows = picassoItems.map(item => `
    <tr>
      <td style="font-weight:500">${esc(truncate(item.feature, 40))}</td>
      <td>${esc(item.mission || '—')}</td>
      <td>${badge(item.status || '—')}</td>
      <td style="font-size:11px;color:#94A3B8">${item.eta ? new Date(item.eta).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '—'}</td>
    </tr>`).join('')

  return slideWrap('🎨 Feature Parity — Picasso', `
    <div class="card" style="overflow:auto;flex:1">
      <table class="s-table">
        <thead><tr><th>Feature</th><th>Mission</th><th>Status</th><th>ETA</th></tr></thead>
        <tbody>${rows}</tbody>
      </table>
    </div>`, 'Feature Parity')
}

function slideExecTracker(items) {
  const activeItems = items.filter(i => i.status === 'active')
  const resolvedItems = items.filter(i => i.status === 'resolved')

  const renderItem = (item) => `
    <div class="card" style="margin-bottom:12px">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">
        <span style="font-size:14px;font-weight:600;color:#1a1a2e">${esc(truncate(item.title || item.issue, 60))}</span>
        ${badge(item.status === 'active' ? 'Active' : 'Resolved', item.status === 'active' ? 'badge-red' : 'badge-green')}
      </div>
      ${item.notes || item.action ? `<div style="font-size:12px;color:#64748B">${esc(truncate(item.notes || item.action, 100))}</div>` : ''}
      ${item.owner ? `<div style="font-size:11px;color:#94A3B8;margin-top:6px">Owner: ${esc(item.owner)}</div>` : ''}
    </div>`

  const content = `
    <div class="two-col">
      <div>
        <div class="section-label">🔴 Active Issues (${activeItems.length})</div>
        ${activeItems.map(renderItem).join('')}
      </div>
      <div>
        <div class="section-label">✅ Resolved (${resolvedItems.length})</div>
        ${resolvedItems.map(renderItem).join('')}
      </div>
    </div>`

  return slideWrap('🎯 Executive Tracker', content, 'Executive Tracker')
}

function slideMembers(members) {
  const rows = members.map(m => `
    <tr>
      <td style="font-weight:500">${esc(m.name || m.fullName || m.alias || '—')}</td>
      <td>${esc(m.role || '—')}</td>
      <td>${esc(m.squad || '—')}</td>
      <td style="font-size:11px;color:#94A3B8">${esc(m.email || '—')}</td>
    </tr>`).join('')

  return slideWrap('👥 Squad Members', `
    <div class="card">
      <table class="s-table">
        <thead><tr><th>Name</th><th>Role</th><th>Squad</th><th>Email</th></tr></thead>
        <tbody>${rows}</tbody>
      </table>
    </div>`, 'Squad Members')
}

function slideWrap(title, bodyHtml, section) {
  const sec = section || 'Other'
  return `
    <div class="slide" data-section="${esc(sec)}">
      <div class="slide-header">
        <div class="slide-title">${title}</div>
        <div class="slide-meta">
          <div class="slide-date">__DATE__</div>
        </div>
      </div>
      <div class="slide-body">${bodyHtml}</div>
      <div class="slide-footer">
        <span class="brand">HAPPY TRACKER</span>
        <span class="brand">Discover Canvas Squad</span>
      </div>
    </div>`
}

// --- MAIN GENERATOR ---

export function generateSlidesHTML(allData, tabFilter) {
  const { workItems = [], featureParity = [], execTracker = [], members = [], weeklySummaries = {} } = allData
  const date = new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })

  const slides = []
  const all = !tabFilter

  // 1. Cover
  slides.push(slideCover(tabFilter ? tabTitle(tabFilter) : 'Discover Canvas Squad · C2', date))

  // 2. Dashboard / Overview
  if ((all || tabFilter === 'dashboard') && workItems.length) slides.push(slideDashboard(workItems))

  // 3. Week Over Week (before work items)
  if ((all || tabFilter === 'week-over-week') && workItems.length) {
    const weekGroups = {}
    workItems.forEach(item => {
      const w = item.flightWeek || 'Unscheduled'
      if (!weekGroups[w]) weekGroups[w] = []
      weekGroups[w].push(item)
    })
    const weekOrder = ['W0', 'W1', 'W2', 'W3', 'W4', 'W5', 'W6', 'W7', 'W8', 'Unscheduled']
    weekOrder.forEach(week => {
      if (weekGroups[week]?.length) {
        slides.push(slideWoW(week, weekGroups[week], weeklySummaries[week], members))
      }
    })
  }

  // 4. Work Items (grouped by status)
  if ((all || tabFilter === 'work-items') && workItems.length) {
    slides.push(...slideWorkItemsGrouped(workItems, members))
  }

    // 5. Feature Parity
  if ((all || tabFilter === 'feature-parity') && featureParity.length) {
    slides.push(...slideFeatureParity(featureParity))
    const picassoSlide = slideFeatureParityPicasso(featureParity)
    if (picassoSlide) slides.push(picassoSlide)
  }

  // 6. Executive Tracker (only when explicitly requested)
  if (tabFilter === 'executive-tracker' && execTracker.length) slides.push(slideExecTracker(execTracker))

  // 7. Members (only when explicitly requested)
  if (tabFilter === 'members' && members.length) slides.push(slideMembers(members))

  const slidesHtml = slides.map(s => s.replace(/__DATE__/g, date)).join('\n')
  const totalSlides = slides.length

  return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Discover Canvas Squad C2 Overview — ${date}</title>
<style>${COPILOT_STYLES}</style>
</head>
<body>
<div class="slide-container">
${slidesHtml}
</div>

<div class="nav-bar">
  <button class="nav-arrow" onclick="navigate(-1)">◀</button>
  <div id="sections" class="section-nav"></div>
  <span class="nav-count" id="counter">1 / ${totalSlides}</span>
  <button class="nav-arrow" onclick="navigate(1)">▶</button>
</div>

<script>
let current = 0;
const slides = document.querySelectorAll('.slide');
const total = slides.length;

function showSlide(n) {
  slides.forEach((s, i) => s.classList.toggle('active', i === n));
  document.getElementById('counter').textContent = (n + 1) + ' / ' + total;
  // Highlight current section
  const currentSection = slides[n]?.dataset.section || '';
  document.querySelectorAll('.section-btn').forEach(btn => {
    btn.classList.toggle('active', btn.dataset.section === currentSection);
  });
}

function navigate(dir) {
  current = (current + dir + total) % total;
  showSlide(current);
}

// Build section nav
const sectionsEl = document.getElementById('sections');
const sectionMap = [];
const seen = new Set();
slides.forEach((s, i) => {
  const sec = s.dataset.section;
  if (sec && sec !== 'Cover' && !seen.has(sec)) {
    seen.add(sec);
    sectionMap.push({ name: sec, firstSlide: i });
  }
});
sectionMap.forEach((sec, idx) => {
  if (idx > 0) {
    const sep = document.createElement('div');
    sep.className = 'section-sep';
    sectionsEl.appendChild(sep);
  }
  const btn = document.createElement('button');
  btn.className = 'section-btn';
  btn.textContent = sec.name;
  btn.dataset.section = sec.name;
  btn.onclick = () => { current = sec.firstSlide; showSlide(current); };
  sectionsEl.appendChild(btn);
});

// Keyboard navigation
document.addEventListener('keydown', (e) => {
  if (e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); navigate(1); }
  if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); navigate(-1); }
  if (e.key === 'Home') { current = 0; showSlide(0); }
  if (e.key === 'End') { current = total - 1; showSlide(current); }
  if (e.key === 'f' || e.key === 'F') {
    if (document.fullscreenElement) document.exitFullscreen();
    else document.documentElement.requestFullscreen();
  }
});

// Touch swipe
let touchStartX = 0;
document.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; });
document.addEventListener('touchend', e => {
  const dx = e.changedTouches[0].clientX - touchStartX;
  if (Math.abs(dx) > 50) navigate(dx > 0 ? -1 : 1);
});

showSlide(0);
</script>
</body>
</html>`
}

function tabTitle(t) {
  const map = { 'dashboard': 'Cycle Overview', 'work-items': 'Work Items', 'week-over-week': 'Week Over Week', 'feature-parity': 'Feature Parity', 'executive-tracker': 'Executive Tracker', 'members': 'Squad Members' }
  return map[t] || 'Happy Tracker'
}
